import { APP_INITIALIZER, NgModule } from '@angular/core';
import { environment } from 'environments/environment';
import { ConfigService } from './config.service';
import { RuntimeConfigService } from './runtime-config.service';
import { provideConfig, provideDefaultConfig } from './config-providers';
import { HealthCheckService } from 'core/services/health-check.service';

export function configInitializerFactory(
  runtimeConfigService: RuntimeConfigService,
  configService: ConfigService,
  healthCheck: HealthCheckService,
) {
  return async () => {
    await runtimeConfigService.load();
    (environment as any).FREELY_API_URL = runtimeConfigService.apiUrl;
    configService.initialize();
    // Health check runs sequentially after config so it uses the resolved
    // FREELY_API_URL. Errors are swallowed — the service flips the store
    // to "maintenance" if the endpoint is unreachable.
    await healthCheck.check();
  }
}

@NgModule({

  providers: [
    provideDefaultConfig({}),
    provideConfig({}),
    RuntimeConfigService,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configInitializerFactory,
      deps: [RuntimeConfigService, ConfigService, HealthCheckService],
      multi: true,
    },
  ]
})
export class ConfigModule { }
